import React from 'react';
import { AccountIdenticon } from '@make-software/csprclick-ui';
import { BodyText, FlexRow, formatHash, HashLength, Link, Tooltip } from '@make-software/cspr-design';
import styled from 'styled-components';

const StyledAccountInfoText = styled(BodyText)(({ theme }) => ({
  color: theme.styleguideColors.contentBlue,
  '& > *': {
    color: theme.styleguideColors.contentBlue
  },
  '&:hover > *': {
    color: theme.styleguideColors.fillPrimaryRed
  },
  '&:active > *': {
    color: theme.styleguideColors.fillPrimaryRedClick
  }
}));

interface AccountInfoCellProps {
  accountHash?: string;
  publicKey: string;
}

export const AccountInfoCell: React.FC<AccountInfoCellProps> = ({ publicKey, accountHash }) => {
  const hash = publicKey || accountHash || '';
  const accountPath = `${config.cspr_live_url}/account/${hash}`;

  return (
    <FlexRow align="center" itemsSpacing={12}>
      <AccountIdenticon hex={hash} size="m" />
      <Tooltip scale={'xs'} lineHeight={'xs'} paddingScale={1} tooltipContent={publicKey} caption={'Public key'}>
        <BodyText size={3} scale={'sm'}>
          <Link href={accountPath} target={'_blank'} color={'hash'}>
            <StyledAccountInfoText size={2} monotype>
              {formatHash(hash, HashLength.TINY)}
            </StyledAccountInfoText>
          </Link>
        </BodyText>
      </Tooltip>
    </FlexRow>
  );
};
